import React, { useState } from 'react'
import ReactPlayer, { Config } from 'react-player/lazy'
import { styled } from '@mui/material'

import CloudflareImage from '@ecm/ui/element/CloudflareImage'

type PlayerProps = {
  className?: string
  config?: Config
  id?: string
  url: string
  posterUrl?: string
  onStart?: () => void
}

const Player = styled(({ className, config, id, url, posterUrl, onStart }: PlayerProps) => {
  const [playing, setPlaying] = useState(false)

  return (
    <div id={id} className={className} onClick={() => setPlaying(!playing)}>
      <div className="player-wrapper">
        <ReactPlayer
          url={url}
          className="react-player"
          width="100%"
          height="100%"
          onStart={onStart}
          playIcon={<CloudflareImage src="/images/icon/ev-play.svg" width={72} height={72} />}
          playing={playing}
          light={posterUrl}
          controls={playing}
          config={config}
        />
      </div>
    </div>
  )
})({
  '.player-wrapper': {
    '.react-player': {
      cursor: 'pointer',
      left: 0,
      position: 'absolute',
      top: 0,
    },
    paddingTop: '56.25% !important' /* 720 / 1280 = 0.5625 */,
    position: 'relative',
  },
  height: '100%',
  width: '100%',
})

export default Player
